
import React, { useState, useEffect, useRef} from "react";
import { withRouter } from 'react-router-dom';
import Fullcalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import ReactDOM from "react-dom";
import { formatVehicleEventTime } from "utils/vehicleBooking";
import { Col, Row, Label } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const _color = [
  { id: 1, color: '#3788d8' },
  { id: 2, color: '#0E6251' },
  { id: 3, color: '#9A7D0A' },
  { id: 4, color: '#8E44AD' },
  { id: 5, color: '#E67E22' },
  { id: 6, color: '#6D4C41' },
  { id: 12, color: '#0077ff' }
];

const defaultColors = [
  '#2563eb', '#059669', '#d97706', '#7c3aed', '#db2777', '#0891b2',
  '#ea580c', '#4f46e5', '#16a34a', '#ca8a04', '#9333ea', '#e11d48'
];

const getContrastTextColor = (bgColor) => {
  if (!bgColor || typeof bgColor !== 'string') return '#ffffff';
  let color = bgColor.trim();
  if (color.startsWith('#')) {
    color = color.substring(1);
    if (color.length === 3) {
      color = color.split('').map(c => c + c).join('');
    }
    if (color.length === 6) {
      const r = parseInt(color.substr(0, 2), 16);
      const g = parseInt(color.substr(2, 2), 16);
      const b = parseInt(color.substr(4, 2), 16);
      const yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 150 ? '#1e293b' : '#ffffff';
    }
  }
  return '#ffffff';
};

const getColorForId = (id) => {
  if (id === undefined || id === null) return '#2563eb';
  const found = _color.find(c => c.id === id);
  if (found && (found.color || found.forecolor)) return found.color || found.forecolor;
  if (typeof id === 'number' && id > 0) {
    return defaultColors[(id - 1) % defaultColors.length];
  }
  if (typeof id === 'string' && id.length > 0) {
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
      hash = (hash << 5) - hash + id.charCodeAt(i);
      hash |= 0;
    }
    const idx = Math.abs(hash) % defaultColors.length;
    return defaultColors[idx];
  }
  return '#2563eb';
};

const Calendar = (props) => {
  var moment = require('moment');
  require('moment/locale/th');
  const { defaultDate, customHeader, events, id, disabledCreate, minTime='08:00:00', maxTime='21:00:00', ...other } = props;
  const [DefaultDate, setDefaultDate] = useState(moment().format("YYYY-MM-DD") );

  var calendarRef = React.createRef();

  useEffect(() => {
    if (defaultDate != null && defaultDate != '')
    {
      setDefaultDate(defaultDate);
      //console.log(defaultDate);

      if (calendarRef.current && typeof calendarRef.current.getApi === "function") {
        let calendarApi = calendarRef.current.getApi();
        calendarApi.gotoDate(defaultDate);
      }
    }
      
 
  },[defaultDate]);

    const handleTimeSelect = (args) => {
        //alert('จองห้อง '+id+' เวลา ' + args.startStr + ' ถึง ' + args.endStr);
        if (!disabledCreate) {
            var meetingName = prompt("ระบุชื่อเรื่องการประชุม")
            if (meetingName != null && meetingName != '') {
                props.history.push({
                    pathname: 'request',
                    state: {
                        roomKey: id,
                        meetingName: meetingName,
                        startDatetime: moment(args.startStr).format('YYYY-MM-DD HH:mm'),
                        stopDatetime: moment(args.endStr).format('YYYY-MM-DD HH:mm')
                    }
                })
            }
        };
    }

  const handleDateClick = (args) => {
    //console.log(args);
  };

  function handleClick(e) {
    if (props.onEventClick) {
      props.onEventClick(e);
      return;
    }

    //console.log(e.event._def.publicId);

    if(e.event._def.publicId != null && e.event._def.publicId != ''){
      props.history.push({
        pathname: 'request',
        state: {
          meetingID: e.event._def.publicId
        }  
      })
    }

    // if (props.onChange) {
    //   props.onChange(e);
    //   setValue(val);
    // }
  }
  
  const resolvedColor = props.color || getColorForId(id);
  const headerColor = props.headerColor || resolvedColor || '#1e293b';
  const eventBgColor = props.eventBackgroundColor || resolvedColor || '#2563eb';
  const eventTextColor = props.eventTextColor || props.textColor;

  function renderEventContent(eventInfo) {
    if (props.eventContent) {
      return props.eventContent(eventInfo);
    }

    const roomKey = eventInfo.event.extendedProps && eventInfo.event.extendedProps.roomKey;
    const _c = roomKey !== undefined ? _color.find(c => c.id === roomKey) : undefined;
    const isCancel = eventInfo.event.extendedProps && eventInfo.event.extendedProps.isCancel == true;

    const currentBgColor =
      eventInfo.event.backgroundColor ||
      (_c && _c.color) ||
      eventBgColor;

    let colorTxt;
    if (isCancel) {
      colorTxt = 'red';
    } else if (eventInfo.event.textColor) {
      colorTxt = eventInfo.event.textColor;
    } else if (eventTextColor) {
      colorTxt = eventTextColor;
    } else if (
      _c &&
      _c.forecolor &&
      _c.forecolor.toLowerCase() !== (_c.color || '').toLowerCase() &&
      _c.forecolor.toLowerCase() !== currentBgColor.toLowerCase()
    ) {
      colorTxt = _c.forecolor;
    } else {
      colorTxt = getContrastTextColor(currentBgColor);
    }

    if (!isCancel && colorTxt && currentBgColor && colorTxt.toLowerCase() === currentBgColor.toLowerCase()) {
      colorTxt = getContrastTextColor(currentBgColor);
    }

    const bgTxt = isCancel ? 'white' : '';

    return (
      <>
        <div className="fc-event-time" style={{ color: colorTxt, background: bgTxt }}>
          {formatVehicleEventTime(eventInfo)}
        </div>
        <div className="fc-event-title" style={{ color: colorTxt, background: bgTxt }}>
          {isCancel ? "ยกเลิก " : ""} {eventInfo.event.title}
        </div>
      </>
    );
  }

  return (
    <div style={{textAlign:'center'}}>
      <Fullcalendar
              initialDate={defaultDate}
              ref={calendarRef}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView={"timeGridDay"}
              headerToolbar={{
                  start: "", // will normally be on the left. if RTL, will be on the right
                  center: "",
                  end: "", // will normally be on the right. if RTL, will be on the left
              }}
              allDaySlot={false}
              dayHeaderContent={<div style={{ color: headerColor }}>{customHeader + ' ' + moment(defaultDate).format('DD MMM BBBB')}</div>}
        dayHeaderClassNames={{color:'red'}}
        height={"75vh"}
        dateClick={handleDateClick}
        events={events}
        droppable={true}
        rerenderDelay={10}
        eventDurationEditable={false}
        //editable={true}
        //eventClick={}
        eventClick={handleClick}
        slotMinTime={minTime}
        slotMaxTime={maxTime}
        locale={'th'}
        selectable={true}
        select={handleTimeSelect}
        selectOverlap={false}
        eventBackgroundColor={eventBgColor}
        eventBorderColor={eventBgColor}
        eventTextColor={eventTextColor || '#ffffff'}
        eventContent={renderEventContent}
      />
    </div>
  );
}

export default withRouter(Calendar);
